import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { ROUTE_PATH_LIST } from '../../../constants/route'
import { isSubArchive } from '../../../utils/route'
import {
  EntityProfileHeader,
  EntityProfileHeaderTitleActionsSelect,
} from '../../Entity'
import {
  useEmailProfileActionsContext,
  useEmailProfileContext,
} from '../Email.hooks'

import * as styles from './EmailProfileHeader.module.css'

function EmailProfileHeader({
  Actions = EntityProfileHeaderTitleActionsSelect,
  AISummary = null,
  BackButton,
  actionsProps: {
    className: actionsClassName = styles.actions,
    ...actionsProps
  } = EMPTY_OBJECT,
  aiSummaryProps,
  getActions,
  ...restProps
} = EMPTY_OBJECT) {
  const { t } = useTranslation()

  const {
    entityData,
    handleCloseModal,
    isInitiated,
    setModal,
    sub,
    widgetsData,
  } = useEmailProfileContext()

  const { handleClickAction } = useEmailProfileActionsContext()

  const headerProps = {
    Actions,
    BackButton,
    EntityAvatar: null,
    actionsProps: {
      ...actionsProps,
      actions: getActions?.({ entityData, sub, t, widgetsData }),
      className: actionsClassName,
      onClickAction: handleClickAction,
    },
    isArchived: entityData?.soft_archived ?? isSubArchive(sub),
    sectionBackUrl: `/${ROUTE_PATH_LIST.mails}`,
    text: entityData?.subject,
  }

  return (
    <>
      <EntityProfileHeader
        {...restProps}
        Footer={null}
        InfoItems={null}
        headerProps={headerProps}
        isLoading={!isInitiated}
        onCloseModal={handleCloseModal}
        onSetModal={setModal}
      />
      {AISummary ? (
        <div className={styles.aiSummaryContainer}>
          <AISummary {...aiSummaryProps} />
        </div>
      ) : null}
    </>
  )
}

export default EmailProfileHeader
